import { ADD_USER_TABS, REMOVE_USER_TABS, SET_ACTIVE_USER, SET_EXPANDED_USER_TAB, CLEAN_EXPANDED_USER_TAB, CLOSE_ALL_TABS, UPDATE_USER_TABS, SET_ACTIVE_CHANNEL } from '../types/tabs'

const initialCvTabsState = { expandedUserTab: '', activeUser: '', users: [], activeChannel: '' }

export default function tabs(state = initialCvTabsState, action) {
  // We don't have user, do not perform any action
  // Made this way because user can be an undefined value! Ex: close all tabs
  if (!Object.prototype.hasOwnProperty.call(action, 'user')) return state

  switch (action.type) {
    case ADD_USER_TABS: {
      const users = [].concat(state.users)

      if (users.map(user => user.id).indexOf(action.user) === -1 && users.length < 15) users.push({ id: action.user, channel: action.channel })

      return Object.assign({}, state, { users })
    }
    case REMOVE_USER_TABS: {
      const users = [].concat(state.users)
      const userToRemove = users.map(user => user.id).indexOf(action.user)

      if (userToRemove === -1) return state

      users.splice(userToRemove, 1)

      let activeUser = state.activeUser
      let activeChannel = state.activeChannel

      if (activeUser === action.user) {
        const newActiveUser = users[userToRemove] || users[userToRemove - 1] || users[userToRemove + 1] || undefined
        if(newActiveUser){
          activeUser = newActiveUser.id
          activeChannel = newActiveUser.channel
        } else {
          activeUser = ''
          activeChannel = ''
        }
      }

      return Object.assign({}, state, { users, activeUser, activeChannel })
    }
    case SET_ACTIVE_USER: {
      return Object.assign({}, state, { activeUser: action.user })
    }
    case SET_ACTIVE_CHANNEL: {
      return Object.assign({}, state, { activeChannel: action.channel })
    }
    case SET_EXPANDED_USER_TAB: {
      return Object.assign({}, state, { expandedUserTab: action.user })
    }
    case CLEAN_EXPANDED_USER_TAB: {
      return Object.assign({}, state, { expandedUserTab: state.expandedUserTab === action.user && '' })
    }
    case CLOSE_ALL_TABS: {
      return initialCvTabsState
    }
    case UPDATE_USER_TABS: {
      return Object.assign({}, state, { users: action.users, activeUser: action.user })
    }

    default: {
      return state
    }
  }
}
